import { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { toast } from "react-toastify";
import load from "../../../assets/Images/loader.gif";




const PriceCalculatorPG = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const [loading, setLoading] = useState(false);

    const [originalPlanList, setOriginalPlanList] = useState([]);
    const [planNameUni, setPlanNameUni] = useState("");
    const [planName, setPlanName] = useState("");
    const [planCrmIdA, setPlanCrmIdA] = useState("");
    const [planCrmIdB, setPlanCrmIdB] = useState("");
    const [basePlan, setBasePlan] = useState("");
    const [basePlanDetail, setBasePlanDetail] = useState([]);
    const [smartTvCount, setSmartTvCount] = useState("");
    const [cctvCount, setCctvCount] = useState("");
    const [dvrCount, setDvrCount] = useState("");
    const [ioTDevicesCount, setIoTDevicesCount] = useState("");
    const [staticIPCount, setStaticIPCount] = useState("");
    const [devicePackCount, setDevicePackCount] = useState("");
    const [wiredLANPortsCount, setWiredLANPortsCount] = useState("");

    const [discountValueTV, setDiscountValueTV] = useState("");
    const [discountValueCCTV, setDiscountValueCCTV] = useState("0");
    const [discountValueDVR, setDiscountValueDVR] = useState("0");

    const [otcPriceDisA, setOtcPriceDisA] = useState("");
    const [otcPriceDisB, setOtcPriceDisB] = useState("");
    const [basePriceDisA, setBasePriceDisA] = useState(""); // Discount Percentage
    const [basePriceDisB, setBasePriceDisB] = useState("");
    const [discountedBasePriceA, setDiscountedBasePriceA] = useState("");
    const [discountedBasePriceB, setDiscountedBasePriceB] = useState("");

    const [otcPriceA, setOctPriceA] = useState("");
    const [otcPriceB, setOctPriceB] = useState("");
    const [listPriceA, setListPriceA] = useState("");
    const [listPriceB, setListPriceB] = useState("");
    const [otcPerRoomOptionA, setOtcPerRoomOptionA] = useState("");
    const [otcPerRoomOptionB, setOtcPerRoomOptionB] = useState("");
    const [sdPerRoomOptionA, setSdPerRoomOptionA] = useState("");
    const [sdPerRoomOptionB, setSdPerRoomOptionB] = useState("");
    const [recommendedPrice, setRecommendedPrice] = useState("");

    const [smartTVRes, setSmartTVRes] = useState("");
    const [ccTvRes, setCcTvRes] = useState("");
    const [dvrRes, setDvrRes] = useState("");
    const [iotRes, setIotRes] = useState("");
    const [staticIpRes, setStaticIpRes] = useState("");
    const [devicePackRes, setDevicePackRes] = useState("");
    const [wiredLanRes, setwiredLanRes] = useState("");

    const [smartTVprice, setSmartTVprice] = useState("");
    const [ccTvprice, setCcTvprice] = useState("");
    const [dvrprice, setDvrprice] = useState("");
    const [iotprice, setIotprice] = useState("");
    const [staticIpprice, setStaticIpprice] = useState("");

    const [wiredLanprice, setwiredLanprice] = useState("");



    const [tvCalValue, setTvcalValue] = useState("");
    const [cctvCalValue, setCctvcalValue] = useState("");
    const [dvrCalValue, setDvrcalValue] = useState("");
    const [iotCalValue, setIotcalValue] = useState("");
    const [staticIpCalValue, setstaticIpcalValue] = useState("");
    const [wiredLanCalValue, setWiredLancalValue] = useState("");

    const [freeTvcount, setFreeTvcount] = useState("");
    const [tvDiscountPrice, setTvDiscountPrice] = useState("");


    const [proposalCounter, setProposalCounter] = useState("");


    const [tableArea, setTableArea] = useState(false);
    const [oppStatus, setOppStatus] = useState("");

    const [optionA, setOptionA] = useState("");
    const [optionB, setOptionB] = useState("");
    const [optionBoth, setOptionBoth] = useState("");
    const [optionAdata, setOptionAdata] = useState("");
    const [optionBdata, setOptionBdata] = useState("");
    const [optionBothdata, setOptionBothdata] = useState("");

    const [billingCycleA, setBillingCycleA] = useState("");
    const [billingCycleB, setBillingCycleB] = useState("");



    const [isDiscountTVChecked, setIsDiscountTVChecked] = useState(false);

    const [userPriceData, setUserPriceData] = useState({
        baseOtcReasonA: "",
        baseOtcReasonB: "",
        pgName: "",
        roomCount: "",
        basePrice: "",
        basePriceDisA: "",
        basePriceDisB: "",
        basePriceReasonA: "",
        basePriceReasonB: ""
    });

    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setUserPriceData({ ...userPriceData, [e.target.name]: e.target.value });
    };


    const handleOtcPriceDisA = (e) => {
        setOtcPriceDisA(e.target.value);
    };


    const handleOtcPriceDisB = (e) => {
        setOtcPriceDisB(e.target.value);
    };

    const calculateDiscountedPriceA = () => {
        const discount = parseFloat(basePriceDisA);
        // Subtracting absolute discount value
        const newPrice = listPriceA - discount;
        // Calculating the discount percentage
        const discountPercent = (discount / listPriceA) * 100;
        const listPriceper = listPriceA * 15 / 100
        // console.log("listPriceper", listPriceper);
        // setBasePriceDisPercent(discountPercent.toFixed(2));
        setDiscountedBasePriceA(newPrice);
    };

    const handleBasePriceDisA = (e) => {
        setBasePriceDisA(e.target.value);
    };

    // Update discounted price when discount input loses focus
    useEffect(() => {
        calculateDiscountedPriceA();
    }, [listPriceA, basePriceDisA]);


    const calculateDiscountedPriceB = () => {
        const discount = parseFloat(basePriceDisB);
        // Subtracting absolute discount value
        const newPrice = listPriceB - discount;
        // Calculating the discount percentage
        const discountPercent = (discount / listPriceB) * 100;
        const listPriceper = listPriceB * 15 / 100
        // console.log("listPriceper", listPriceper);
        // setBasePriceDisPercent(discountPercent.toFixed(2));
        setDiscountedBasePriceB(newPrice);
    };

    const handleBasePriceDisB = (e) => {
        setBasePriceDisB(e.target.value);
    };

    // Update discounted price when discount input loses focus
    useEffect(() => {
        calculateDiscountedPriceB();
    }, [listPriceB, basePriceDisB]);



    const handleTVDiscountCheckChange = (event) => {
        // if (!basePlan) {
        //     toast.warning("Please Select Base Plan", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        const isChecked = event.target.checked;
        setIsDiscountTVChecked(isChecked);

        if (isChecked && basePlan) {

        } else {
            setDiscountValueTV("")
            setSmartTvCount("");
        }

    };


    const handleSmartTvCount = async (e) => {
        const newValueTv = e.target.value;
        setSmartTvCount(newValueTv);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "smartTVPG",
                tvCount: newValueTv,
                discount: discountValueTV,
                planName: basePlan?.value,
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });
            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setSmartTVRes(result.Response)

            if (planCrmIdA == "Prod_004262_ID" || planCrmIdB == "Prod_002774_ID") {
                const freeTv = newValueTv - 1
                const tvCalculation = freeTv * result?.Response?.PricePerUnit

                console.log("tvCalculation", tvCalculation);
                setFreeTvcount(freeTv);
                setTvcalValue(tvCalculation);
            } else if (newValueTv > userPriceData.roomCount) {
                const freeTv = newValueTv - userPriceData.roomCount
                const tvCalculation = freeTv * result?.Response?.PricePerUnit
                console.log("tvCalculation", tvCalculation);
                setTvcalValue(tvCalculation);
                console.log("userPriceData.roomCount", freeTv);

                setFreeTvcount(freeTv);
            } else {
                setFreeTvcount("0");
                setTvcalValue("0");
            }

        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleSmartTvDiscount = (e) => {
        const value = e.target.value;
        setDiscountValueTV(value);

        let discountcal = 0;
        let discountPercentage = 0;
        let tvFreeCal = 0;
        if (planCrmIdA == "Prod_004262_ID" || planCrmIdB == "Prod_002774_ID") {
            tvFreeCal = smartTvCount - 1
            discountPercentage = (value / smartTVprice) * 100;
            console.log("Discount %:", discountPercentage);
        } else {
            tvFreeCal = smartTvCount - userPriceData.roomCount

            discountPercentage = (value / smartTVprice) * 100;
            console.log("Discount %:", discountPercentage);
        }
        // setDiscountpercent(discountPercentage)

        if (discountPercentage > 60) {
            alert("Discount cannot be more than 60%");
            setDiscountValueTV("")
        } else if (planCrmIdA == "Prod_004262_ID" || planCrmIdB == "Prod_002774_ID") {
            const discountTv = smartTVprice - value
            setTvDiscountPrice(discountTv)
            const finalValue = discountTv * tvFreeCal
            setTvcalValue(finalValue);
        } else {
            const discountTv = smartTVprice - value
            setTvDiscountPrice(discountTv)
            const finalValue = discountTv * tvFreeCal
            // console.log("finaldiscountTv", finalValue);
            setTvcalValue(finalValue);
        }


    }

    const handleCctvCount = async (e) => {
        const newValueCcTv = e.target.value;
        setCctvCount(newValueCcTv);
        // if (e.target.value) setDvrCount("");
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "cctvCameraPG",
                discount: discountValueCCTV,
                cctvCount: newValueCcTv,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setCcTvRes(result.Response);

            const cctvCalculation = newValueCcTv * result?.Response?.PricePerUnit
            console.log("cctvCalculation", cctvCalculation);
            setCctvcalValue(cctvCalculation);

        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };


    const handleDvrCount = async (e) => {
        const newValueDvr = e.target.value;
        setDvrCount(newValueDvr);
        // if (e.target.value) setCctvCount("");
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "DVR_NVRPG",
                discount: discountValueDVR,
                cctvCount: newValueDvr,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setDvrRes(result.Response);
            const dvrFree = newValueDvr

            const dvrCalculation = dvrFree * result?.Response?.PricePerUnit
            console.log("dvrCalculation", dvrCalculation);
            setDvrcalValue(dvrCalculation);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };



    const handleIoTDevicesCount = async (e) => {
        const newValueIot = e.target.value;
        setIoTDevicesCount(newValueIot);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "IOT_devicePG",
                IOTcount: newValueIot,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setIotRes(result.Response);
            const iotCalculation = newValueIot * result?.Response?.PricePerUnit
            console.log("iotCalculation", iotCalculation);
            setIotcalValue(iotCalculation);

        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleStaticIPCount = async (e) => {
        const newValueStaticIp = e.target.value;
        setStaticIPCount(newValueStaticIp);

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "staticIPPG",
                staticIP: newValueStaticIp,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setStaticIpRes(result.Response);
            const staticIpCalculation = newValueStaticIp * result?.Response?.PricePerUnit
            console.log("staticIpCalculation", staticIpCalculation);
            setstaticIpcalValue(staticIpCalculation);

        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleDevicePackCount = (e) => {
        setDevicePackCount(e.target.value);
    };

    const handleWiredLANPortsCount = async (e) => {
        const newValueWireLan = e.target.value;
        setWiredLANPortsCount(newValueWireLan);

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "wiredLAN_PORT_PG",
                LANport: newValueWireLan,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setwiredLanRes(result.Response);
            const wiredLanCalculation = newValueWireLan * result?.Response?.PricePerUnit
            console.log("wiredLanCalculation", wiredLanCalculation);
            setWiredLancalValue(wiredLanCalculation);


        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };



    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const navigate = useNavigate();

    const redirectOpportunity = () => {
        navigate(`/businessPgOpp?OppId=${OppId}`);
    };

    useEffect(() => {
        const fetchGetopportunity = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                setOppStatus(result.Response?.Data[0]?.Status);
                // console.log("API Response :", result.Response.Data[0].PgInfo);
                setUserPriceData({
                    pgName: result.Response?.Data[0]?.PgInfo.PGName,
                    roomCount: result.Response?.Data[0]?.PgInfo.NumberofRooms
                })

                setProposalCounter(result.Response.Data[0]?.PgInfo.ProposalCounter);


                // let tanantPGtype = result?.Response?.Data[0]?.PgInfo.TenantType;
                // try {
                //     const apiUrl = process.env.REACT_APP_API_URL_3;
                //     const requestData = {
                //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                //         Action: "getPGType",
                //     };

                //     const response = await fetch(apiUrl, {
                //         method: "POST",
                //         headers: {
                //             "Content-Type": "application/json",
                //         },
                //         body: JSON.stringify(requestData),
                //     });

                //     const result = await response.json();

                //     // console.log("API Response :", result);
                //     const pgTanantType = result?.Response?.map((option) => ({
                //         label: option?.type_name,
                //         value: option?.crm_plan_id,
                //     }));
                //     const filterPgType = pgTanantType?.find((data) => data.value == tanantPGtype)
                //     // console.log("filterPgType",filterPgType);

                //     setPgType({
                //         label: filterPgType?.label,
                //         value: filterPgType.value,
                //     });
                // } catch (error) {
                //     console.error("Error fetching data:", error.message);
                // } finally {
                // }

            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
            }
        };
        fetchGetopportunity();
    }, []);


    useEffect(() => {
        const fetchAllAddOnPrices = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const Authkey = "ac7b51de9d888e1458dd53d8aJAN3ba6f";

                const payloads = [
                    {
                        Action: "smartTVPG",
                        tvCount: "",
                        discount: "",
                        planName: "",
                    },
                    {
                        Action: "cctvCameraPG",
                        cctvCount: "",
                        discount: "",
                    },
                    {
                        Action: "IOT_devicePG",
                        IOTcount: "",
                    },
                    {
                        Action: "DVR_NVRPG",
                        cctvCount: "",
                        discount: "",
                    },
                    {
                        Action: "staticIPPG",
                        staticIP: "",
                    },
                    {
                        Action: "wiredLAN_PORT_PG",
                        LANport: "",
                    },
                ];

                const requests = payloads.map((body) =>
                    fetch(apiUrl, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ Authkey, ...body }),
                    }).then((res) => res.json())
                );

                const [
                    smartTVRes,
                    cctvRes,
                    iotRes,
                    dvrRes,
                    staticIPRes,
                    lanPortRes,
                ] = await Promise.all(requests);

                setSmartTVprice(smartTVRes?.Response?.PricePerUnit);
                setCcTvprice(cctvRes?.Response?.PricePerUnit);
                setDvrprice(dvrRes?.Response?.PricePerUnit);
                setIotprice(iotRes?.Response?.PricePerUnit);
                setStaticIpprice(staticIPRes?.Response?.PricePerUnit);
                setwiredLanprice(lanPortRes?.Response?.PricePerUnit);



            } catch (error) {
                console.error("Error fetching add-on prices:", error);
            }
        };

        fetchAllAddOnPrices();
    }, []);



    useEffect(() => {
        const fetchGetPlans = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "getPlanPG",
                    roomCount: userPriceData?.roomCount
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                const fullPlans = result?.Response || [];
                // console.log("Plan Response:", result.Response);
                // Save full plan list for future lookup
                setOriginalPlanList(fullPlans);

                const plans = result?.Response?.map((plan) => ({
                    label: plan.description,
                    value: plan.crm_id,
                }));
                setBasePlanDetail(plans);
                // setPlanDescription(result?.Response?.description);

            } catch (error) {
                console.error("Error fetching Plans:", error.message);
            }
        };

        fetchGetPlans();
    }, [userPriceData?.roomCount]);


    const handleBasePlan = async (selectedOption) => {
        // console.log("Selected Base Plan:", selectedOption);
        setBasePlan(selectedOption);
        setOptionA("")
        setOptionB("")
        setOptionBoth("")

        setSmartTvCount("");
        setCctvCount("");
        setDvrCount("");
        setIoTDevicesCount("");
        setStaticIPCount("");
        setWiredLANPortsCount("");

        setTvcalValue("");
        setCctvcalValue("");
        setDvrcalValue("");
        setIotcalValue("");
        setstaticIpcalValue("");
        setWiredLancalValue("");


        const selectedPlan = basePlanDetail.find(
            (plan) => plan.value === selectedOption.value
        );

        if (selectedPlan) {
            // You need to also store planNameUni in basePlanDetail earlier
            // console.log("selectedPlan",selectedPlan);
            //  console.log("originalPlanList",originalPlanList);
            const fullPlan = originalPlanList.find(
                (plan) => plan.crm_id === selectedOption.value
            );
            console.log("fullPlan", fullPlan);
            if (fullPlan) {
                // console.log("fullPlan.planNameUni",fullPlan.planNameUni);

                setPlanNameUni(fullPlan.planNameUni);
                setPlanName(fullPlan.plan_name);
                // setPlanCrmId(fullPlan.crm_id)
            }
        }

    };


    const handleOptionA = async (e) => {
        const isChecked = e.target.checked;
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else {
            setOptionA(isChecked ? "A" : "");
            if (isChecked) {
                setOptionB("");
                setOptionBoth("");
                try {
                    const apiUrl = process.env.REACT_APP_API_URL_3;
                    const requestData = {
                        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        "Action": "getPGPlanDetails",
                        "option": "A",
                        "planID": planNameUni,
                        "roomCount": userPriceData.roomCount
                    };
                    const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    });
                    const result = await response.json();
                    console.log("result", result.Response);

                    setOptionAdata(result?.Response);
                    setOptionBdata("");

                    const planA = result.Response?.find(item => item.optionType === "A");
                    if (planA) {
                        // setOptionAdata([planA]); // wrap in array to preserve table `.map()`
                        setListPriceA(planA.listPricePerRoom);

                        setPlanCrmIdA(planA.crm_id)
                        setListPriceB("");
                        setBasePriceDisB("");
                        setOtcPriceDisB("");
                        setOtcPerRoomOptionA(planA.otc);
                        setSdPerRoomOptionA(planA.sd);
                        setOtcPerRoomOptionB("");
                        setSdPerRoomOptionB("");
                        setBillingCycleA(planA.billingFrequency);
                        setBillingCycleB("");

                        // Optional: populate billing cycle dropdown
                        // setBillingCycleOption([{ label: planA.billingFrequency, value: planA.billingFrequency }]);
                    } else {
                        toast.error("Option A plan not found in response");
                    }


                    // const transformedOptions = result?.Response?.map(
                    //     (option) => ({
                    //         label: option.billingFrequency,
                    //         value: option.billingFrequency,
                    //     })
                    // );
                    // setBillingCycleOption(transformedOptions)


                } catch (error) {
                    console.error("Error fetching Plans:", error);
                }
            }
        }
    };

    const handleOptionB = async (e) => {
        const isChecked = e.target.checked;
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else {
            setOptionB(isChecked ? "B" : "");
            if (isChecked) {
                setOptionA("");
                setOptionBoth("");
                try {
                    const apiUrl = process.env.REACT_APP_API_URL_3;
                    const requestData = {
                        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        "Action": "getPGPlanDetails",
                        "option": "B",
                        "planID": planNameUni,
                        "roomCount": userPriceData.roomCount
                    };
                    const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    });

                    const result = await response.json();
                    setOptionBdata(result?.Response);
                    setOptionAdata("");


                    const planB = result.Response?.find(item => item.optionType === "B");
                    if (planB) {
                        // setOptionAdata([planA]); // wrap in array to preserve table `.map()`
                        setListPriceB(planB.listPricePerRoom);

                        setPlanCrmIdB(planB.crm_id);
                        setListPriceA("");
                        setBasePriceDisA("");
                        setOtcPriceDisA("")
                        setOtcPerRoomOptionB(planB.otc);
                        setSdPerRoomOptionB(planB.sd);
                        setOtcPerRoomOptionA("");
                        setSdPerRoomOptionA("");
                        setBillingCycleB(planB.billingFrequency);
                        setBillingCycleA("");

                        // Optional: populate billing cycle dropdown
                        // setBillingCycleOption([{ label: planA.billingFrequency, value: planA.billingFrequency }]);
                    } else {
                        toast.error("Option B plan not found in response");
                    }


                } catch (error) {
                    console.error("Error fetching Plans:", error);
                }
            }
        }


    };

    const handleOptionBoth = async (e) => {
        const isChecked = e.target.checked;
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else {
            setOptionBoth(isChecked ? "C" : "");
            if (isChecked) {
                setOptionA("");
                setOptionB("");
                try {
                    const apiUrl = process.env.REACT_APP_API_URL_3;
                    const requestData = {
                        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        "Action": "getPGPlanDetails",
                        "option": "C",
                        "planID": planNameUni,
                        "roomCount": userPriceData?.roomCount
                    };
                    const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    });

                    const result = await response.json();

                    // setOptionAdata(result?.Response[0]);
                    // setOptionBdata(result?.Response[1]);
                    const planOptionA = result?.Response?.find(item => item.optionType === "A");
                    const planOptionB = result?.Response?.find(item => item.optionType === "B");

                    if (planOptionA && planOptionB) {
                        setOptionAdata([planOptionA]); // ✅ wrap in array for .map()
                        setOptionBdata([planOptionB]);

                        setListPriceA(planOptionA?.listPricePerRoom);
                        setOtcPerRoomOptionA(planOptionA?.otc);
                        setSdPerRoomOptionA(planOptionA?.sd);
                        setBillingCycleA(planOptionA.billingFrequency);
                        setPlanCrmIdA(planOptionA?.crm_id);

                        setPlanCrmIdB(planOptionB?.crm_id);
                        setListPriceB(planOptionB?.listPricePerRoom);
                        setOtcPerRoomOptionB(planOptionB?.otc);
                        setSdPerRoomOptionB(planOptionB?.sd);
                        setBillingCycleB(planOptionB.billingFrequency);

                    } else {
                        toast.error("Option A-B plan not found in response");
                    }

                } catch (error) {
                    console.error("Error fetching Plans:", error);
                }
            }
        }
    };






    const handleCalculate = () => {
        setTableArea(true);
    }






    const customOption = (props) => {
        const { data, innerRef, innerProps, isFocused } = props;
        return (
            <div
                ref={innerRef}
                {...innerProps}
                // data-tooltip-id={`tooltip-${data.value}`}
                data-tooltip-content={data.label}
                style={{
                    backgroundColor: isFocused ? "#cddbf7" : "white", // Highlight on hover
                    color: isFocused ? "black" : "black",
                    padding: "10px",
                    // cursor: "pointer",
                }}
            >
                {data.label}
                {/* <Tooltip id={`tooltip-${data.value}`} /> */}
            </div>
        );
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "35px",
            whiteSpace: "normal",
            overflow: "visible",
        }),
        menu: (provided) => ({
            ...provided,
            maxHeight: "200px", // Ensures dropdown is scrollable
            overflowY: "auto",
            scrollbarWidth: "thin",
            WebkitOverflowScrolling: "touch", // Enables smooth scrolling on iOS
        }),
        singleValue: (provided) => ({
            ...provided,
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
        }),
        option: (provided, { isFocused }) => ({
            ...provided,
            backgroundColor: isFocused ? "#007bff" : "white",
            color: isFocused ? "white" : "black",
            cursor: "pointer",
        }),
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };



    const totalProductPriceOptionA = discountedBasePriceA ? userPriceData?.roomCount * discountedBasePriceA : userPriceData?.roomCount * listPriceA
    // console.log("totalProductPriceOptionA",totalProductPriceOptionA);

    const totalAddonForAopt = (+tvCalValue || 0) +
        (+cctvCalValue || 0) +
        (+dvrCalValue || 0) +
        (+iotCalValue || 0) +
        (+staticIpCalValue || 0) +
        (+wiredLanCalValue || 0)
    const totalReccurringAmountoptA = totalProductPriceOptionA + totalAddonForAopt //listprice * roomCount + Addon
    const totalBillingAmountAopt = totalReccurringAmountoptA * 6  //totalrecurringprice * billing frequecy
    const effectivePriceA = totalReccurringAmountoptA / userPriceData?.roomCount


    // option- B calculation
    const totalProductPriceOptionB = discountedBasePriceB ? userPriceData?.roomCount * discountedBasePriceB : userPriceData?.roomCount * listPriceB
    const totalAddonForBopt =
        (+tvCalValue || 0) +
        (+cctvCalValue || 0) +
        (+dvrCalValue || 0) +
        (+iotCalValue || 0) +
        (+staticIpCalValue || 0) +
        (+wiredLanCalValue || 0)
    const totalReccurringAmountoptB = totalProductPriceOptionB + totalAddonForBopt //listprice * roomCount + Addon
    const totalBillingAmountBopt = totalReccurringAmountoptB * 3   //totalrecurringprice * billing frequecy
    const effectivePriceB = totalReccurringAmountoptB / userPriceData?.roomCount


    // const optionAotc = otcPerRoomOptionA * userPriceData?.roomCount
    // const optionBotc = otcPerRoomOptionB * userPriceData?.roomCount
    const optionAsd = sdPerRoomOptionA * userPriceData?.roomCount
    const optionBsd = sdPerRoomOptionB * userPriceData?.roomCount

    const [optionAotc, setOptionAotc] = useState(0);
    const [optionBotc, setOptionBotc] = useState(0);

    useEffect(() => {
        if (!userPriceData?.roomCount) return;

        let value = 0;
        if (otcPriceDisA) {
            let discountedOTC = otcPerRoomOptionA - otcPriceDisA;
            value = discountedOTC * userPriceData.roomCount;
        } else {
            value = otcPerRoomOptionA * userPriceData.roomCount;
        }
        setOptionAotc(value);
    }, [otcPerRoomOptionA, otcPriceDisA, userPriceData?.roomCount]);

     useEffect(() => {
        if (!userPriceData?.roomCount) return;
        
        let value = 0;
        if (otcPriceDisB) {
            let discountedOTC = otcPerRoomOptionB - otcPriceDisB;
            value = discountedOTC * userPriceData.roomCount;
        } else {
            value = otcPerRoomOptionB * userPriceData.roomCount;
        }
        setOptionBotc(value);
    }, [otcPerRoomOptionB, otcPriceDisB, userPriceData?.roomCount]);






    const handleCreatefirstProposal = async () => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Action": "createFirstOptyProductPG",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "UserName": sessionStorage.getItem('userName'),
                "Password": sessionStorage.getItem('password'),
                "OpportunityID": OppId ? OppId : "",
                "RoomCount": userPriceData?.roomCount,
                "SmartTV": smartTvCount,
                "CCTV": cctvCount,
                "IoT": ioTDevicesCount,
                "DVR": dvrCount,
                "StaticIP": staticIPCount,
                "WiredLAN": wiredLANPortsCount
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });
            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate(`/businessPgOpp?OppId=${OppId}`);
            } else {
                toast.warning(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        } finally {
            setLoading(false);
        }
    }

    // { console.log("basePriceDisA", basePriceDisA) }
    // { console.log("userPriceData.basePriceReasonA", userPriceData.basePriceReasonA) }

    const handleCreateProduct = async () => {

        if (optionA && basePriceDisA > 50 && basePriceDisA <= 100 && !userPriceData.basePriceReasonA) {
            toast.warning("Please Select Base Price Discount Reason for Option A", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        if (optionA && otcPriceDisA > 50 && otcPriceDisA <= 100 && !userPriceData.basePriceReasonA) {
            toast.warning("Please Select OTC Price Discount Reason for Option A", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }


        if (optionB && basePriceDisB > 50 && basePriceDisB <= 100 && !userPriceData.basePriceReasonB) {
            toast.warning("Please Select Base Price Discount Reason for Option B", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        if (optionB && otcPriceDisB > 50 && otcPriceDisB <= 100 && !userPriceData.basePriceReasonB) {
            toast.warning("Please Select OTC Price Discount Reason for Option B", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            // Create an array dynamically based on device counts
            let addOns = [];
            let basePlanDetail = {};
            if (optionA) {
                basePlanDetail = {
                    "OpportunityID": OppId,
                    "RoomCount": userPriceData?.roomCount,
                    "OptionType": "Option A",
                    "ProductID": planCrmIdA,
                    "RC": discountedBasePriceA ? userPriceData.roomCount * discountedBasePriceA : userPriceData.roomCount * listPriceA,
                    "OTC": optionAotc,
                    "SD": optionAsd,
                    "TotalRecurringPrice": totalReccurringAmountoptA.toFixed(2),
                    "BillingAmount": totalBillingAmountAopt,
                    "EffectivePrice": effectivePriceA ? effectivePriceA.toFixed(2) : "",
                    "BaseFloorPriceDiscount": basePriceDisA,
                    "OTCPriceDiscount": otcPriceDisA,
                    "TotalAmount": 0
                }
            } else {
                basePlanDetail = {
                    "OpportunityID": OppId,
                    "RoomCount": userPriceData?.roomCount,
                    "OptionType": "Option B",
                    "ProductID": planCrmIdB,
                    "RC": discountedBasePriceB ? userPriceData.roomCount * discountedBasePriceB : userPriceData.roomCount * listPriceB,
                    "OTC": optionBotc,
                    "SD": optionBsd,
                    "TotalRecurringPrice": totalReccurringAmountoptB.toFixed(2),
                    "BillingAmount": totalBillingAmountBopt,
                    "EffectivePrice": effectivePriceB ? effectivePriceB.toFixed(2) : "",
                    "BaseFloorPriceDiscount": basePriceDisB,
                    "OTCPriceDiscount": otcPriceDisB,
                    "TotalAmount": 0
                }
            }
            if (smartTvCount) {
                addOns.push({
                    "ProductID": smartTVRes ? smartTVRes?.crm_product_id : "",
                    "Quantity": freeTvcount,
                    "PricePerUnit": discountValueTV ? tvDiscountPrice : smartTVRes?.PricePerUnit,
                    "Discount": isDiscountTVChecked ? discountValueTV : 0,
                    "Extendedamount": tvCalValue,
                    "TotalQuantity": smartTvCount
                });
            }
            if (cctvCount) {
                addOns.push({
                    "ProductID": ccTvRes ? ccTvRes?.crm_product_id : "",
                    "Quantity": cctvCount,
                    "PricePerUnit": ccTvRes ? ccTvRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": cctvCalValue,
                    "TotalQuantity": cctvCount
                });
            }

            if (dvrCount) {
                addOns.push({
                    "ProductID": dvrRes ? dvrRes?.crm_product_id : "",
                    "Quantity": dvrCount,
                    "PricePerUnit": dvrRes ? dvrRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": dvrCalValue,
                    "TotalQuantity": dvrCount
                });
            }
            if (ioTDevicesCount) {
                addOns.push({
                    "ProductID": iotRes ? iotRes?.crm_product_id : "",
                    "Quantity": ioTDevicesCount,
                    "PricePerUnit": iotRes ? iotRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": iotCalValue,
                    "TotalQuantity": ioTDevicesCount
                });
            }
            if (staticIPCount) {
                addOns.push({
                    "ProductID": staticIpRes ? staticIpRes?.crm_product_id : "",
                    "Quantity": staticIPCount,
                    "PricePerUnit": staticIpRes ? staticIpRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": staticIpCalValue,
                    "TotalQuantity": staticIPCount
                });
            }
            if (wiredLANPortsCount) {
                addOns.push({
                    "ProductID": wiredLanRes ? wiredLanRes?.crm_product_id : "",
                    "Quantity": wiredLANPortsCount,
                    "PricePerUnit": wiredLanRes ? wiredLanRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": wiredLanCalValue,
                    "TotalQuantity": wiredLANPortsCount
                });
            }
            const requestData = {
                "Action": "updateOptyProductPGAB",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "UserName": sessionStorage.getItem("userName"),
                "Password": sessionStorage.getItem("password"),
                "Baseplan": basePlanDetail,
                "AddOn": addOns
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

                navigate(`/businessPgOpp?OppId=${OppId}`);
                if ((basePriceDisA && basePriceDisA > 50 && basePriceDisA <= 100) || (otcPriceDisA && otcPriceDisA > 50 && otcPriceDisA <= 100)) {

                    try {
                        const apiUrl = process.env.REACT_APP_API_URL;
                        const requestData = {
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "Action": "createApprovals",
                            "userName": sessionStorage.getItem("userName"),
                            "password": sessionStorage.getItem("password"),
                            "OppId": OppId,
                            "Reason": userPriceData.basePriceReasonA
                        }
                        const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(requestData),
                        });

                        const result = await response.json();
                        // console.log("Plan Response:", result.Response);
                        if (result?.Response?.StatusCode == 200) {
                            toast.success(result?.Response?.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                        }

                    } catch (error) {
                        console.error("Error fetching Plans:", error.message);
                    }

                } else if ((basePriceDisB && basePriceDisB > 50 && basePriceDisB <= 100) || (otcPriceDisB && otcPriceDisB > 50 && otcPriceDisB <= 100)) {
                    try {
                        const apiUrl = process.env.REACT_APP_API_URL;
                        const requestData = {
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "Action": "createApprovals",
                            "userName": sessionStorage.getItem("userName"),
                            "password": sessionStorage.getItem("password"),
                            "OppId": OppId,
                            "Reason": userPriceData.basePriceReasonB
                        }
                        const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(requestData),
                        });

                        const result = await response.json();
                        // console.log("Plan Response:", result.Response);
                        if (result?.Response?.StatusCode == 200) {
                            toast.success(result?.Response?.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                        }

                    } catch (error) {
                        console.error("Error fetching Plans:", error.message);
                    }
                }
            } else {
                toast.warning(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }


        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        } finally {
            setLoading(false);
        }

    }

    const handleCreateProductBoth = async () => {


        if (optionBoth && basePriceDisA > 50 && basePriceDisA <= 100 && !userPriceData.basePriceReasonA) {
            toast.warning("Please Select Base Price Discount Reason for Option A", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        if (optionBoth && otcPriceDisA > 50 && otcPriceDisA <= 100 && !userPriceData.basePriceReasonA) {
            toast.warning("Please Select OTC Price Discount Reason for Option A", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }


        if (optionBoth && basePriceDisB > 50 && basePriceDisB <= 100 && !userPriceData.basePriceReasonB) {
            toast.warning("Please Select Base Price Discount Reason for Option B", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        if (optionBoth && otcPriceDisB > 50 && otcPriceDisB <= 100 && !userPriceData.basePriceReasonB) {
            toast.warning("Please Select OTC Price Discount Reason for Option B", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            let addOns = [];

            if (smartTvCount) {
                addOns.push({
                    "ProductID": smartTVRes ? smartTVRes?.crm_product_id : "",
                    "Quantity": freeTvcount,
                    "PricePerUnit": discountValueTV ? tvDiscountPrice : smartTVRes?.PricePerUnit,
                    "Discount": isDiscountTVChecked ? discountValueTV : 0,
                    "Extendedamount": tvCalValue,
                    "TotalQuantity": smartTvCount
                });
            }
            if (cctvCount) {
                addOns.push({
                    "ProductID": ccTvRes ? ccTvRes?.crm_product_id : "",
                    "Quantity": cctvCount,
                    "PricePerUnit": ccTvRes ? ccTvRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": cctvCalValue,
                    "TotalQuantity": cctvCount
                });
            }
            if (dvrCount) {
                addOns.push({
                    "ProductID": dvrRes ? dvrRes?.crm_product_id : "",
                    "Quantity": dvrCount,
                    "PricePerUnit": dvrRes ? dvrRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": dvrCalValue,
                    "TotalQuantity": dvrCount
                });
            }

            if (ioTDevicesCount) {
                addOns.push({
                    "ProductID": iotRes ? iotRes?.crm_product_id : "",
                    "Quantity": ioTDevicesCount,
                    "PricePerUnit": iotRes ? iotRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": iotCalValue,
                    "TotalQuantity": ioTDevicesCount
                });
            }
            if (staticIPCount) {
                addOns.push({
                    "ProductID": staticIpRes ? staticIpRes?.crm_product_id : "",
                    "Quantity": staticIPCount,
                    "PricePerUnit": staticIpRes ? staticIpRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": staticIpCalValue,
                    "TotalQuantity": staticIPCount
                });
            }
            if (wiredLANPortsCount) {
                addOns.push({
                    "ProductID": wiredLanRes ? wiredLanRes?.crm_product_id : "",
                    "Quantity": wiredLANPortsCount,
                    "PricePerUnit": wiredLanRes ? wiredLanRes?.PricePerUnit : "",
                    "Discount": 0,
                    "Extendedamount": wiredLanCalValue,
                    "TotalQuantity": wiredLANPortsCount,
                });
            }
            const requestData = {
                "Action": "createOptyProductPGBoth",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "UserName": sessionStorage.getItem("userName"),
                "Password": sessionStorage.getItem("password"),
                "OpportunityID": OppId,
                "RoomCount": userPriceData?.roomCount,
                "OptionType": "Both",
                "Baseplan": [
                    {
                        "PlanName": planName
                    }
                ],
                "OptionA": {
                    "RC": discountedBasePriceA ? userPriceData.roomCount * discountedBasePriceA : userPriceData.roomCount * listPriceA,
                    "MRC": discountedBasePriceA ? userPriceData.roomCount * discountedBasePriceA : userPriceData.roomCount * listPriceA,
                    "OTC": optionAotc,
                    "SD": optionAsd,
                    "TotalRecurringPrice": totalReccurringAmountoptA.toFixed(2),
                    "BillingAmount": totalBillingAmountAopt,
                    "EffectivePrice": effectivePriceA ? effectivePriceA.toFixed(2) : "",
                    "BasePriceDiscount": basePriceDisA,
                    "OTCPriceDiscount": otcPriceDisA,
                    "ProductID": planCrmIdA,
                    "DiscountReason": userPriceData.basePriceReasonA ? userPriceData.basePriceReasonA : ""
                },
                "OptionB": {
                    "RC": discountedBasePriceB ? userPriceData.roomCount * discountedBasePriceB : userPriceData.roomCount * listPriceB,
                    "MRC": discountedBasePriceB ? userPriceData.roomCount * discountedBasePriceB : userPriceData.roomCount * listPriceB,
                    "OTC": optionBotc,
                    "SD": optionBsd,
                    "TotalRecurringPrice": totalReccurringAmountoptB.toFixed(2),
                    "BillingAmount": totalBillingAmountBopt,
                    "EffectivePrice": effectivePriceB ? effectivePriceB.toFixed(2) : "",
                    "BasePriceDiscount": basePriceDisB,
                    "OTCPriceDiscount": otcPriceDisB,
                    "ProductID": planCrmIdB,
                    "DiscountReason": userPriceData.basePriceReasonB ? userPriceData.basePriceReasonB : ""
                },
                "AddOn": addOns
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);

            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

                // setTimeout(() => {
                //     window.location.reload()
                // }, 1000);
                navigate(`/businessPgOpp?OppId=${OppId}`);


                if (
                    (basePriceDisA && basePriceDisA > 50 && basePriceDisA <= 100) ||
                    (basePriceDisB && basePriceDisB > 50 && basePriceDisB <= 100) ||
                    (otcPriceDisA && otcPriceDisA > 50 && otcPriceDisA <= 100) ||
                    (otcPriceDisB && otcPriceDisB > 50 && otcPriceDisB <= 100)
                ) {
                    try {
                        const apiUrl = process.env.REACT_APP_API_URL;
                        const requestData = {
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "Action": "createApprovals",
                            "userName": sessionStorage.getItem("userName"),
                            "password": sessionStorage.getItem("password"),
                            "OppId": OppId,
                            "Reason": ""
                        }
                        const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(requestData),
                        });

                        const result = await response.json();
                        // console.log("Plan Response:", result.Response);
                        if (result?.Response?.StatusCode == 200) {
                            toast.success(result?.Response?.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                        }

                    } catch (error) {
                        console.error("Error fetching Plans:", error.message);
                    }
                }


            } else {
                toast.warning(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        } finally {
            setLoading(false);
        }
    }


    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectOpportunity}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-2">PG Plan Selector</span>
                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (

                <div className="container-fluid form-container">
                    <div className="container shadow mb-3 bg-body rounded mt-4" id="form1">
                        <form className="lead-form p-2">
                            <div className="container text-light Header-style border p-1 mt-3">
                                <span>PG Details</span>
                            </div>



                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className=" mt-4">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            PG Name*
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter PG Name"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="pgName"
                                            name="pgName"
                                            value={userPriceData.pgName}
                                            onChange={handleChange}
                                            style={{ backgroundColor: "transparent" }}
                                            readOnly
                                        />

                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Room Count*
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Room Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="roomCount"
                                            name="roomCount"
                                            value={userPriceData.roomCount}
                                            onChange={handleChange}
                                            style={{ backgroundColor: "transparent" }}
                                            readOnly
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    // &&  (userPriceData.roomCount < 9 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                </div>



                                {(proposalCounter !== "" && proposalCounter !== "0") && (
                                    <>
                                        <div className="col-12 col-md-6">
                                            <div className="">
                                                <label className="select-search-label mt-3">Base Plan Name</label>

                                                <Select
                                                    className="basic-single form-control form-control-sm p-1"
                                                    classNamePrefix="select"
                                                    placeholder="Select Option"
                                                    id="basePlan"
                                                    name="basePlan"
                                                    styles={customStyles}
                                                    components={{ Option: customOption }}
                                                    value={basePlan}
                                                    onChange={handleBasePlan}
                                                    options={basePlanDetail.map((data) => ({
                                                        value: data.value,
                                                        label: data.label,
                                                    }))}
                                                    isSearchable={false}
                                                    menuPlacement="auto" // Prevents dropdown from cutting off
                                                    menuPosition="fixed"
                                                // isDisabled={oppStatus !== "Open"}
                                                />
                                            </div>
                                        </div>

                                        {/* {console.log("basePlan",basePlan)} */}


                                        <div className="container my-3 mx-3">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-check ">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="checkA"
                                                            value="checkA"
                                                            checked={optionA}
                                                            onChange={handleOptionA}
                                                        />
                                                        <label className="form-check-label" htmlFor="checkA">
                                                            Option - A
                                                        </label>
                                                    </div>
                                                </div>
                                                {/* {console.log("optionA", optionA)} */}
                                                <div className="col-md-4">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="checkB"
                                                            checked={optionB}
                                                            onChange={handleOptionB}
                                                        />
                                                        <label className="form-check-label" htmlFor="checkB">
                                                            Option - B
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="checkBoth"
                                                            checked={optionBoth}
                                                            onChange={handleOptionBoth}
                                                        />
                                                        <label className="form-check-label" htmlFor="checkBoth">
                                                            Both
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>





                                        {(optionA == "A" || optionBoth == "C") &&
                                            <>
                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            List Price (Option-A)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Base Price"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="basePrice"
                                                            name="basePrice"
                                                            // value={userPriceData.basePrice}
                                                            value={listPriceA}
                                                        // onChange={handleChange}
                                                        />

                                                    </div>
                                                </div>


                                              
                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            Add Base price Discount (Option-A)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Base price Discount"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="basePriceDisA"
                                                            name="basePriceDisA"
                                                            value={basePriceDisA}
                                                            onChange={handleBasePriceDisA}
                                                            onBlur={calculateDiscountedPriceA}
                                                            disabled={oppStatus !== "Open"}
                                                            style={{ background: "transparent" }}
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = [
                                                                    "Backspace",
                                                                    "Delete",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Tab",
                                                                ];
                                                                const input = e.target.value;

                                                                // Prevent entering '0' as the first character
                                                                if (input.length === 0 && e.key === "0") {
                                                                    e.preventDefault();
                                                                    return;
                                                                }
                                                                const isDigit = /\d/.test(e.key);
                                                                if (
                                                                    (isDigit || allowedKeys.includes(e.key))
                                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                                ) {
                                                                    return true;
                                                                } else {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {basePriceDisA > 100 &&
                                                        <p className="mt-1" style={{ marginLeft: "20px", color: "red" }}>Discount cannot be more than 100</p>
                                                    }

                                                    {basePriceDisA > 50 && basePriceDisA <= 100 &&
                                                        <p className="mt-1 text-primary" style={{ marginLeft: "20px" }}>Approval Request will be Generated</p>
                                                    }
                                                </div>
                                             

                                             {/* <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            OTC Price (Option-A)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Base Price"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="otcPerRoomOptionA"
                                                            name="otcPerRoomOptionA"
                                                            // value={userPriceData.basePrice}
                                                            value={otcPerRoomOptionA}
                                                        // onChange={handleChange}
                                                        />

                                                    </div>
                                                </div>


                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            OTC Discount (Option-A)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Base price Discount"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="otcPriceDisA"
                                                            name="otcPriceDisA"
                                                            value={otcPriceDisA}
                                                            onChange={handleOtcPriceDisA}
                                                            // onBlur={calculateDiscountedPriceA}
                                                            disabled={oppStatus !== "Open"}
                                                            style={{ background: "transparent" }}
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = [
                                                                    "Backspace",
                                                                    "Delete",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Tab",
                                                                ];
                                                                const input = e.target.value;

                                                                // Prevent entering '0' as the first character
                                                                if (input.length === 0 && e.key === "0") {
                                                                    e.preventDefault();
                                                                    return;
                                                                }
                                                                const isDigit = /\d/.test(e.key);
                                                                if (
                                                                    (isDigit || allowedKeys.includes(e.key))
                                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                                ) {
                                                                    return true;
                                                                } else {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {otcPriceDisA > 100 &&
                                                        <p className="mt-1" style={{ marginLeft: "20px", color: "red" }}>Discount cannot be more than 100</p>
                                                    }

                                                    {otcPriceDisA > 50 && otcPriceDisA <= 100 &&
                                                        <p className="mt-1 text-primary" style={{ marginLeft: "20px" }}>Approval Request will be Generated</p>
                                                    }
                                                </div> */}



                                               
{/* 
                                                {!isNaN(discountedBasePriceA) && discountedBasePriceA !== null && discountedBasePriceA !== undefined && (
                                                    <div className="col-12 m-3">
                                                        <p className=""><strong>Discounted Base Price (option-A): {discountedBasePriceA}</strong></p>
                                                    </div>)}  */}
                                            </>}

                                        {(optionB == "B" || optionBoth == "C") &&
                                            <>
                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            List Price (Option-B)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Base Price"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="basePrice"
                                                            name="basePrice"
                                                            // value={userPriceData.basePrice}
                                                            value={listPriceB}
                                                        // onChange={handleChange}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            Add Base price Discount (Option-B)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Base price Discount"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="basePriceDisB"
                                                            name="basePriceDisB"
                                                            value={basePriceDisB}
                                                            onChange={handleBasePriceDisB}
                                                            onBlur={calculateDiscountedPriceB}
                                                            disabled={oppStatus !== "Open"}
                                                            style={{ background: "transparent" }}
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = [
                                                                    "Backspace",
                                                                    "Delete",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Tab",
                                                                ];
                                                                const input = e.target.value;

                                                                // Prevent entering '0' as the first character
                                                                if (input.length === 0 && e.key === "0") {
                                                                    e.preventDefault();
                                                                    return;
                                                                }
                                                                const isDigit = /\d/.test(e.key);
                                                                if (
                                                                    (isDigit || allowedKeys.includes(e.key))
                                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                                ) {
                                                                    return true;
                                                                } else {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {basePriceDisB > 100 &&
                                                        <p className="mt-1" style={{ marginLeft: "20px", color: "red" }}>Discount cannot be more than 100</p>
                                                    }

                                                    {basePriceDisB > 50 && basePriceDisB <= 100 &&
                                                        <p className="mt-1 text-primary" style={{ marginLeft: "20px" }}>Approval Request will be Generated</p>
                                                    }
                                                </div>
                                             
                                                  {/* <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            OTC Price (Option-B)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Base Price"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="otcPriceB"
                                                            name="otcPriceB"
                                                            // value={userPriceData.basePrice}
                                                            value={otcPerRoomOptionB}
                                                        // onChange={handleChange}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            OTC Discount (Option-B)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Base price Discount"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="otcPriceDisB"
                                                            name="otcPriceDisB"
                                                            value={otcPriceDisB}
                                                            onChange={handleOtcPriceDisB}
                                                            // onBlur={calculateDiscountedPriceA}
                                                            disabled={oppStatus !== "Open"}
                                                            style={{ background: "transparent" }}
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = [
                                                                    "Backspace",
                                                                    "Delete",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Tab",
                                                                ];
                                                                const input = e.target.value;

                                                                // Prevent entering '0' as the first character
                                                                if (input.length === 0 && e.key === "0") {
                                                                    e.preventDefault();
                                                                    return;
                                                                }
                                                                const isDigit = /\d/.test(e.key);
                                                                if (
                                                                    (isDigit || allowedKeys.includes(e.key))
                                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                                ) {
                                                                    return true;
                                                                } else {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {otcPriceDisB > 100 &&
                                                        <p className="mt-1" style={{ marginLeft: "20px", color: "red" }}>Discount cannot be more than 100</p>
                                                    }

                                                    {otcPriceDisB > 50 && otcPriceDisB <= 100 &&
                                                        <p className="mt-1 text-primary" style={{ marginLeft: "20px" }}>Approval Request will be Generated</p>
                                                    }
                                                </div> */}
{/* 
                                                

                                                {!isNaN(discountedBasePriceB) && discountedBasePriceB !== null && discountedBasePriceB !== undefined && (
                                                    <div className="col-12 m-3">
                                                        <p className=""><strong>Discounted Base Price (option-B): {discountedBasePriceB}</strong></p>
                                                    </div>)}  */}
                                            </>}



                                        {(optionA == "A" || optionBoth == "C") &&
                                            <>
                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            Reason For Discount (Option-A)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Base price Discount"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="basePriceReasonA"
                                                            name="basePriceReasonA"
                                                            value={userPriceData.basePriceReasonA}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* {!isNaN(discountedBasePriceA) && discountedBasePriceA !== null && discountedBasePriceA !== undefined && (
                                                    <div className="col-12 m-3">
                                                        <p className=""><strong>Discounted Base Price (option-A): {discountedBasePriceA}</strong></p>
                                                    </div>)} */}
                                            </>}

                                        {(optionB == "B" || optionBoth == "C") &&
                                            <>
                                                <div className="col-12 col-md-6">
                                                    <div className="mt-4">
                                                        <label htmlFor="pgName1" className="pg-lable-style">
                                                            Reason For Discount (Option-B)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Base price Discount"
                                                            className="form-control input-text form-control-sm pg-input-style"
                                                            id="basePriceReasonB"
                                                            name="basePriceReasonB"
                                                            value={userPriceData.basePriceReasonB}
                                                            onChange={handleChange}


                                                        />
                                                    </div>

                                                </div>

                                                {/* {!isNaN(discountedBasePriceB) && discountedBasePriceB !== null && discountedBasePriceB !== undefined && (
                                                    <div className="col-12 m-3">
                                                        <p className=""><strong>Discounted Base Price (option-B): {discountedBasePriceB}</strong></p>
                                                    </div>)} */}
                                            </>}

                                        {/* )} */}



                                    </>
                                )}

                            </div>






                            <div className="container text-light Header-style border p-1 mt-4">
                                <span>Add-On Plans</span>

                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="smartTvCount" className="pg-lable-style">
                                            Smart TV Count
                                            {smartTVprice != "0" && <span> ({smartTVprice} per room)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="smartTvCount"
                                            name="smartTvCount"
                                            value={smartTvCount}
                                            onChange={handleSmartTvCount}
                                            // onBlur={handleBlurSmartTvCount}
                                            disabled={oppStatus !== "Open" || isDiscountTVChecked == true}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {(
                                            // Group A: proposalCounter is non-empty/non-zero AND smartTvCount exceeds roomCount
                                            (proposalCounter !== "" &&
                                                proposalCounter !== "0" &&
                                                smartTvCount > userPriceData.roomCount)
                                            ||
                                            // Group B: one of the CRM IDs matches
                                            (planCrmIdA === "Prod_004262_ID" ||
                                                planCrmIdB === "Prod_002774_ID")
                                        ) && (
                                                <div className="form-check m-3">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="applyDiscount"
                                                        checked={isDiscountTVChecked}
                                                        onChange={handleTVDiscountCheckChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="applyDiscount">
                                                        Apply Discount
                                                    </label>
                                                </div>
                                            )}



                                        {isDiscountTVChecked == true && (
                                            <div className="mt-4">
                                                <label htmlFor="smartTvCount" className="pg-lable-style">
                                                    Smart TV Discount
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Count"
                                                    className="form-control input-text form-control-sm pg-input-style"
                                                    id="discountValueTV"
                                                    name="discountValueTV"
                                                    value={discountValueTV}
                                                    onChange={handleSmartTvDiscount}
                                                    disabled={!smartTvCount}
                                                    style={{ background: "transparent" }}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = [
                                                            "Backspace",
                                                            "Delete",
                                                            "ArrowLeft",
                                                            "ArrowRight",
                                                            "Tab",
                                                        ];
                                                        const isDigit = /\d/.test(e.key);
                                                        if (
                                                            (isDigit || allowedKeys.includes(e.key))
                                                            //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                        ) {
                                                            return true;
                                                        } else {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                <span></span>
                                            </div>
                                        )}
                                        <p></p>

                                    </div>
                                </div>

                                {/* {console.log("smartTvCount", smartTvCount)} */}



                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="cctvCount" className="pg-lable-style">
                                            CCTV Count
                                            {ccTvprice != "0" && <span> ({ccTvprice} per Unit)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="cctvCount"
                                            name="cctvCount"
                                            value={cctvCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onChange={handleCctvCount}
                                            // onBlur={handleBlurCctvCount}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="dvrCount" className="pg-lable-style">
                                            DVR/NVR Count
                                            {dvrprice != "0" && <span> ({dvrprice} per Unit)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="dvrCount"
                                            name="dvrCount"
                                            value={dvrCount}
                                            onChange={handleDvrCount}
                                            // onBlur={handleBlurDvrCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />



                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="ioTDevicesCount" className="pg-lable-style">
                                            IoT Devices Count
                                            {iotprice != "0" && <span> ({iotprice} per Unit)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="ioTDevicesCount"
                                            name="ioTDevicesCount"
                                            value={ioTDevicesCount}
                                            onChange={handleIoTDevicesCount}
                                            // onBlur={handleBlurIoTDevicesCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="devicePackCount" className="pg-lable-style">
                                            Static IP Count
                                            {staticIpprice != "0" && <span> ({staticIpprice} per License)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="staticIPCount"
                                            name="staticIPCount"
                                            value={staticIPCount}
                                            onChange={handleStaticIPCount}
                                            // onBlur={handleBlurStaticIPCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="devicePackCount" className="pg-lable-style">
                                            Wired LAN Port Count
                                            {wiredLanprice != "0" && <span> ({wiredLanprice} per License)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="wiredLANPortsCount"
                                            name="wiredLANPortsCount"
                                            value={wiredLANPortsCount}
                                            onChange={handleWiredLANPortsCount}
                                            // onBlur={handleBlurWiredLANCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>






                            {/* {tableArea == true && */}
                            <div className="mt-5">

                                {(optionA || optionB || optionBoth) &&
                                    <div className="p-1">
                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover responsive className="table-sm">
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th colSpan="4">Installation Charges: Spectra Pro-Fi Broadband for PG</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th colSpan="2"></th>
                                                        <th colSpan="1">Option-A</th>
                                                        <th colSpan="1">Option-B</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2">One-Time charges (OTC)</th>
                                                        {/* <th colSpan="1">{Number(otcPerRoomOptionA) * Number(userPriceData?.roomCount)}</th> */}
                                                        <th colSpan="1">{optionAotc}</th>
                                                         <th colSpan="1">{optionBotc}</th>
                                                        {/* <th colSpan="1">{Number(otcPerRoomOptionB?.toString().replace(/,/g, '')) * Number(userPriceData?.roomCount)}</th> */}
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2">Security Deposit (SD)</th>
                                                        <th colSpan="1">{Number(sdPerRoomOptionA) * Number(userPriceData?.roomCount)}</th>
                                                        <th colSpan="1">{sdPerRoomOptionB * userPriceData?.roomCount}</th>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>}



                                {(optionA || optionBoth) &&
                                    <div className="p-1">
                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover responsive className="table-sm">
                                                {/* Table Header */}
                                                <thead className="">
                                                    <tr>
                                                        <th colSpan="5">Option - A</th>
                                                    </tr>
                                                </thead>
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th colSpan="5">Recurring Charges: Spectra Pro-Fi Broadband for PG </th>
                                                    </tr>
                                                </thead>

                                                {/* Table Body */}
                                                <tbody>
                                                    <tr>
                                                        <th colSpan="2">Billing Frequency</th>
                                                        <th colSpan="2" className="table-primary">{billingCycleA} Advance</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Plan Name</th>
                                                        <th>Licence Count</th>
                                                        <th>Plan Rate (Per Month)</th>
                                                        <th>Total Price (Per Month)</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="4">Base Plan Options</th>
                                                    </tr>
                                                    {Array.isArray(optionAdata) && optionAdata?.map((plan, idx) => (
                                                        <tr key={idx}>
                                                            <td className="table-primary">{plan.plan_name}</td>
                                                            <td className="text-end">{userPriceData.roomCount}</td>
                                                            <td className="text-end">{discountedBasePriceA ? discountedBasePriceA : plan.listPricePerRoom}</td>
                                                            <td className="text-end">{discountedBasePriceA ? userPriceData.roomCount * discountedBasePriceA : userPriceData.roomCount * plan.listPricePerRoom}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <th colSpan="4">Add-On Plans</th>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Smart TV Entertainment</td>
                                                        <td className="text-end">{freeTvcount}</td>
                                                        <td className="text-end">{discountValueTV ? tvDiscountPrice : smartTVRes?.PricePerUnit}</td>
                                                        <td className="text-end">{tvCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">CCTV Camera Basic</td>
                                                        <td className="text-end">{cctvCount}</td>
                                                        <td className="text-end">{cctvCount ? ccTvRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{cctvCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">DVR/NVR Basic</td>
                                                        <td className="text-end">{dvrCount}</td>
                                                        <td className="text-end">{dvrCount ? dvrRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{dvrCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Iot Device Basic</td>
                                                        <td className="text-end">{ioTDevicesCount}</td>
                                                        <td className="text-end">{ioTDevicesCount ? iotRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{iotCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Static IP Basic</td>
                                                        <td className="text-end">{staticIPCount}</td>
                                                        <td className="text-end">{staticIPCount ? staticIpRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{staticIpCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Wired LAN Port Basic</td>
                                                        <td className="text-end">{wiredLANPortsCount}</td>
                                                        <td className="text-end">{wiredLANPortsCount ? wiredLanRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{wiredLanCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" className="text-end">Total Reccuring Price (Per Month)</th>
                                                        <th colSpan="2" className="text-end">{totalReccurringAmountoptA.toFixed(2)}</th>
                                                    </tr>
                                                    <tr style={{ backgroundColor: "#6f9c68" }}>
                                                        <th colSpan="2" className="text-end"> Billing Amount (Half-Yearly Basis)</th>
                                                        <th colSpan="2" className="text-end">{totalBillingAmountAopt}</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" className="text-end"> Effective Price (Per Room Per Month)</th>
                                                        <th colSpan="2" className="text-end"><span className="rupee">&#8377; {effectivePriceA ? effectivePriceA.toFixed(2) : ""}</span> </th>

                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                }

                                {(optionB || optionBoth) &&
                                    <div className="p-1">
                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover responsive className="table-sm">
                                                {/* Table Header */}
                                                <thead className="">
                                                    <tr>
                                                        <th colSpan="5">Option - B</th>
                                                    </tr>
                                                </thead>
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th colSpan="5">Recurring Charges: Spectra Pro-Fi Broadband for PG </th>
                                                    </tr>
                                                </thead>

                                                {/* Table Body */}
                                                <tbody>
                                                    <tr>
                                                        <th colSpan="2">Billing Frequency</th>
                                                        <th colSpan="2" className="table-primary">{billingCycleB} Advance</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Plan Name</th>
                                                        <th>Licence Count</th>
                                                        <th>Plan Rate (Per Month)</th>
                                                        <th>Total Price (Per Month)</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="4">Base Plan Options</th>
                                                    </tr>
                                                    {Array.isArray(optionBdata) && optionBdata?.map((plan, idx) => (
                                                        <tr key={idx}>
                                                            <td className="table-primary">{plan.plan_name}</td>
                                                            <td className="text-end">{userPriceData.roomCount}</td>
                                                            <td className="text-end">{discountedBasePriceB ? discountedBasePriceB : plan.listPricePerRoom}</td>
                                                            <td className="text-end">{discountedBasePriceB ? userPriceData.roomCount * discountedBasePriceB : userPriceData.roomCount * plan.listPricePerRoom}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <th colSpan="4">Add-On Plans</th>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Smart TV Entertainment</td>
                                                        <td className="text-end">{freeTvcount}</td>
                                                        <td className="text-end">{discountValueTV ? tvDiscountPrice : smartTVRes?.PricePerUnit}</td>
                                                        <td className="text-end">{tvCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">CCTV Camera Basic</td>
                                                        <td className="text-end">{cctvCount}</td>
                                                        <td className="text-end">{cctvCount ? ccTvRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{cctvCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">DVR/NVR Basic</td>
                                                        <td className="text-end">{dvrCount}</td>
                                                        <td className="text-end">{dvrCount ? dvrRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{dvrCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Iot Device Basic</td>
                                                        <td className="text-end">{ioTDevicesCount}</td>
                                                        <td className="text-end">{ioTDevicesCount ? iotRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{iotCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Static IP Basic</td>
                                                        <td className="text-end">{staticIPCount}</td>
                                                        <td className="text-end">{staticIPCount ? staticIpRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{staticIpCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Wired LAN Port Basic</td>
                                                        <td className="text-end">{wiredLANPortsCount}</td>
                                                        <td className="text-end">{wiredLANPortsCount ? wiredLanRes?.PricePerUnit : ""}</td>
                                                        <td className="text-end">{wiredLanCalValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" className="text-end">Total Reccuring Price (Per Month)</th>
                                                        <th colSpan="2" className="text-end">{totalReccurringAmountoptB.toFixed(2)}</th>
                                                    </tr>
                                                    <tr style={{ backgroundColor: "#6f9c68" }}>
                                                        <th colSpan="2" className="text-end"> Billing Amount ({billingCycleB} Basis)</th>
                                                        <th colSpan="2" className="text-end">{totalBillingAmountBopt}</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" className="text-end"> Effective Price (Per Room Per Month)</th>
                                                        <th colSpan="2" className="text-end"><span className="rupee">&#8377; {effectivePriceB ? effectivePriceB.toFixed(2) : ""}</span> </th>

                                                    </tr>

                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                }

                            </div>
                            {/* } */}
                            {(proposalCounter == "" || proposalCounter == "0") &&
                                <div className=" text-center mt-5 mb-5">
                                    <button
                                        type="button"
                                        className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                        onClick={handleCreatefirstProposal}
                                        disabled={oppStatus !== "Open"}
                                    >
                                        Create Proposal
                                    </button>
                                </div>
                            }

                            

                            {/* {proposalCounter != "" && */}
                            <>
                                {(optionA || optionB) &&
                                    <div className=" text-center mt-5 mb-5">
                                        <button
                                            type="button"
                                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                            onClick={handleCreateProduct}
                                            disabled={oppStatus !== "Open" || !basePlan}
                                        >
                                            Create Proposal
                                        </button>
                                    </div>}

                                {optionBoth &&
                                    <div className=" text-center mt-5 mb-5">
                                        <button
                                            type="button"
                                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                            onClick={handleCreateProductBoth}
                                            disabled={oppStatus !== "Open" || !basePlan}
                                        >
                                            Create Proposal
                                        </button>
                                    </div>}

                            </>
                            {/* } */}


                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default PriceCalculatorPG;